export const createAuth = (getState) => {
    return{
        username: getState()["authState"].orgId,
        password: getState()["authState"].apiKey,
        deviceId: getState()["authState"].deviceId
    }
}